import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_PATH } from "../server-data";
import { axiosAuth } from "./interceptor";

export const getRbacPermissions = (): Promise<string[]> => {
  const authToken = localStorage.getItem("token");

  if (!authToken) {
    return Promise.reject("Auth token is not available.");
  }

  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };

  return axiosAuth
    .get(API_PATH().apis.permissions, config)
    .then((response: AxiosResponse) => {
      return response.data.permissions;
    })
    .catch((error: any) => {
      throw error;
    });
};
